(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    const buttonSlideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-up-visible');
          buttonSlideObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.button-block--slide-up').forEach((el) => {
    buttonSlideObserver.observe(el);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    const groupSlideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-up-visible');
          groupSlideObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.group-block--slide-up').forEach((el) => {
    groupSlideObserver.observe(el);
  });

  (function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const parallaxBlocks = document.querySelectorAll('.group-block--parallax');
    if (!parallaxBlocks.length) return;

    const activeBlocks = new Set();
    let ticking = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activeBlocks.add(entry.target);
          } else {
            activeBlocks.delete(entry.target);
          }
        });
      },
      { rootMargin: '10% 0px' }
    );

    parallaxBlocks.forEach((block) => observer.observe(block));

    function updateParallax() {
      const viewportHeight = window.innerHeight;

      activeBlocks.forEach((block) => {
        const rect = block.getBoundingClientRect();
        const amount = parseInt(getComputedStyle(block).getPropertyValue('--parallax-amount')) || 50;
        const progress = 1 - rect.bottom / (viewportHeight + rect.height);
        const clamped = Math.max(0, Math.min(1, progress));
        const translateY = amount * (1 - 2 * clamped);

        const mediaWrapper = block.querySelector('.group-block__media-wrapper');
        if (mediaWrapper) {
          mediaWrapper.style.transform = `translateY(${translateY}px)`;
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });

    updateParallax();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const staggerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('stagger-visible');
          staggerObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.product-card__content[data-stagger]').forEach((el) => {
    staggerObserver.observe(el);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    const textSlideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-up-visible');
          textSlideObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.text-block--slide-up').forEach((el) => {
    textSlideObserver.observe(el);
  });
  } catch(e) { console.error(e); }
})();

})();
